import { render, staticRenderFns } from "./Cursor.vue?vue&type=template&id=49e21e2b"
import script from "./Cursor.vue?vue&type=script&lang=js"
export * from "./Cursor.vue?vue&type=script&lang=js"
import style0 from "./Cursor.vue?vue&type=style&index=0&id=49e21e2b&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports